export default __webpack_public_path__ + "static/media/ls.0370b393.svg";